import React, { useState, useContext, createContext, useEffect } from "react";
import ColorThief from 'colorthief';
import { useDropzone } from 'react-dropzone';
import { useQuery, useMutation } from "react-query";
import { fetchRandomPhoto, fetchMorePhotos, fetchSearchImages, triggerDownload } from "../../Controllers/unsplash-photo";

const thumb = {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: 8,
    marginRight: 8,
    width: '100%',
    // maxHeight: '300px',
    height: '100%',
    padding: 15,
    boxSizing: 'border-box'
};

const thumbInner = {
    display: 'flex',
    minWidth: 0,
    overflow: 'hidden',
    width: '100%'
};

const img = {
    display: 'block',
    width: '100%',
    height: '100%',
    borderRadius: 5,
    objectFit: 'cover'
};


const imagepickerContext = createContext();
export const Useimagepickercontext = () => useContext(imagepickerContext);

const UseImagePicker = () => {
    const [files, setFiles] = useState([]);
    const [colors, setColors] = useState([]);
    const [storeImageColors, setStoreImageColors] = useState([]);
    const [unsplashImageColors, setUnsplashImageColors] = useState([]);
    const [copy, setCopy] = useState("");
    const [errorMessage, setErrorMessage] = useState(false);
    const [storeRandomPhoto, setStoreRandomPhoto] = useState([]);
    const [showDefaultImage, setShowDefaultImage] = useState(true);
    const [open, setOpen] = useState(false);
    const [storeImages, setStoreImages] = useState([]);
    const [storeImagePath, setStoreImagePath] = useState({
        defaultImagePath: "",
        unsplashImagePath: "",
        storeSearchImages: [],
        loadSearchImageComponent: false,
        value: 0,
        showCrossIcon: false,
        userLink: "",
        userName: "",
        searchTerm: "",
        colorCounter: 5,
        uploadedImageColors: 5,
        unsplashImageColorCounter: 5,
        buttonDisabled: false,
        unsplashImageComponent: false
    })

    const useGetRandomImage = (queryString) =>
        useQuery(["random-image", queryString], () => fetchRandomPhoto(), {
            enabled: true,
            select: (data) => data.data,
            onSuccess: (data) => {
                setShowDefaultImage(true);
                setStoreImagePath((prevState) => ({
                    ...prevState,
                    defaultImagePath: data && data[0].urls.regular,
                    unsplashImagePath: "",
                    userLink: data && data[0].user.links.html,
                    userName: data && data[0].user.first_name
                }))

                const colorThief = new ColorThief()
                const img = new Image();
                img.onload = async () => {
                    const palette = await colorThief.getPalette(img, storeImagePath.colorCounter); // Extract top 5 colors
                    setColors(palette);
                    setStoreImagePath((prevState) => ({
                        ...prevState,
                        value: 0,
                        unsplashImageComponent: false
                    }))
                };
                img.crossOrigin = "Anonymous";
                img.src = data && data[0].urls.regular; // Assuming 'data' is the URL of the fetched image
                setStoreRandomPhoto(data);
            },
            cacheTime: 0
        });

    const { getRootProps, getInputProps } = useDropzone({
        accept: {
            'image/*': []
        },
        onDrop: acceptedFiles => {
            const filesArray = Array.from(acceptedFiles);
            if (filesArray.length === 0) {
                setErrorMessage(true);
                setStoreImageColors([]);
            } else {
                setFiles(filesArray.map(file => Object.assign(file, {
                    preview: URL.createObjectURL(file)
                })));
                setErrorMessage(false);
            }
            extractColors(filesArray);
            setShowDefaultImage(false);
            setOpen(false);
            setColors([]);
            setStoreImagePath((prevState) => ({
                ...prevState,
                uploadedImageColors: 5,
                colorCounter: 5,
                unsplashImageComponent: false
            }))
        }
    });

    const extractColors = async (files) => {
        const colorThief = new ColorThief();
        for (const file of files) {
            const img = new Image();
            img.src = URL.createObjectURL(file);
            img.onload = async () => {
                const palette = await colorThief.getPalette(img, storeImagePath.uploadedImageColors); // Extract top 5 colors
                setStoreImageColors(palette);
                setStoreImagePath((prevState) => ({
                    ...prevState,
                    value: 0,
                    // colorCounter: 5
                }))
            };
        }
    };


    const thumbs = files.map(file => (
        <div style={thumb} key={file.name}>
            <div style={thumbInner}>
                <img
                    src={file.preview}
                    style={img}
                    onLoad={() => {
                        URL.revokeObjectURL(file.preview);
                    }}
                    alt=''
                />
            </div>
        </div>
    ));



    const rgbToHex = (r, g, b) => {
        const toHex = (c) => {
            const hex = c.toString(16);
            return hex.length === 1 ? '0' + hex : hex;
        };
        return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
    };

    const handleColors = (getHexCode) => {
        const copyCode = getHexCode;
        const text = document.createElement("textarea");
        document.body.appendChild(text);
        text.value = copyCode;
        text.select();
        document.execCommand("copy");
        document.body.removeChild(text);
        setCopy(getHexCode);
        localStorage.setItem("hexCode", copy);
        const getCopiedItem = localStorage.getItem("hexCode");
        if (getCopiedItem === "null" || getCopiedItem !== "null") {
            setTimeout(function () {
                setCopy(null);
            }, 3000);
        }
    }



    const { mutate: handleImages, isLoading: imageLoader } = useMutation(
        fetchMorePhotos,
        {
            onSuccess: (data) => {
                setStoreImages(data?.data);

            },
            onError: (err) => {
                console.log(err, "===== error");
            }
        }
    )

    const { mutate: handleSearchApi, isLoading: dataLoader } = useMutation(
        fetchSearchImages,
        {
            onSuccess: (data) => {
                setStoreImagePath((prevState) => ({
                    ...prevState,
                    storeSearchImages: data?.data?.results,
                    showCrossIcon: true
                }))
            },
            onError: (err) => {
                console.log(err, "===== error");
            }
        }
    )

    const handleImageColor = (imagePath, userProfilePath, userFirstName, download_location) => {
        setShowDefaultImage(false);
        setStoreImagePath((prevState) => ({
            ...prevState,
            defaultImagePath: "",
            unsplashImagePath: imagePath,
            userLink: userProfilePath,
            userName: userFirstName,
            unsplashImageComponent: true,
            storeSearchImages: []
        }))
        const colorThief = new ColorThief()
        const img = new Image();
        img.onload = async () => {
            setUnsplashImageColors([]);
            const palette = await colorThief.getPalette(img, storeImagePath.unsplashImageColorCounter); // Extract top 5 colors
            setUnsplashImageColors(palette);
            setStoreImagePath((prevState) => ({
                ...prevState,
                value: 0,
                searchTerm: "",
                showCrossIcon: false,
                loadSearchImageComponent: false
                // colorCounter: 5
            }))
            // setColors([]);
        };
        img.crossOrigin = "Anonymous";
        img.src = imagePath // Assuming 'data' is the URL of the fetched image
        triggerPhotosDownload(download_location);
        setOpen(false);
    }

    const triggerPhotosDownload = (photosDownloadUrl) => {
        mutatePhotosDownload({ photosDownloadUrl });
    }


    const { mutate: mutatePhotosDownload, isLoading: isPhotosLoading } = useMutation(
        triggerDownload,
        {
            onSuccess: (data) => {
                console.log(data, "===== data");
            },
            onError: (err) => {
                console.log(err, "===== error");
            }
        }
    )


    return {
        handleColors,
        colors,
        rgbToHex,
        thumbs,
        getRootProps,
        getInputProps,
        files,
        copy,
        setColors,
        setFiles,
        errorMessage,
        setErrorMessage,
        useGetRandomImage,
        storeRandomPhoto,
        showDefaultImage,
        setStoreImageColors,
        storeImageColors,
        open,
        setOpen,
        handleImages,
        imageLoader,
        storeImages,
        handleImageColor,
        storeImagePath,
        handleSearchApi,
        setStoreImagePath,
        dataLoader,
        unsplashImageColors,
        setUnsplashImageColors
    }
}

export function ProvideImagePicker({ children }) {
    const imagePicker = UseImagePicker();
    return <imagepickerContext.Provider value={imagePicker}>{children}</imagepickerContext.Provider>
}
